import i18n from '@/i18n';
import { isClientError } from 'cesg-shared';
import type { NotificationMatcher } from './notification-matcher';

export const genericErrorNotification: NotificationMatcher = (error) => {
  if (!isClientError(error, 'GENERIC_ERROR')) return null;

  const { t } = i18n.global;
  return {
    title: t('errorNotifications.GENERIC_ERROR.title'),
    text: t('errorNotifications.GENERIC_ERROR.text'),
    type: 'danger',
  };
};
